import DisplayPrice from "components/common/DisplayPrice";
import {
  CustomerDashboardTransactionStatus,
  EntryStatus,
  VehicleCurrentStatus,
} from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatUTCDate } from "utils/utils";

export const DATA = [
  {
    id: "#1",
    carNumber: "ABC 1234",
    transaction: "Monthly Renewal - Unlimited Shine",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 1, // ANPR | Manual
    status: 1,
    paymentMethod: "Card Payment",
    amount: "110",
  },
  {
    id: "#2",
    carNumber: "KSA 5678",
    transaction: "Single Wash Clean",
    package: "Unlimited Protect",
    dateTime: "2025-12-27T12:19:58.083Z",
    entryType: 1,
    status: 2,
    paymentMethod: "Card Payment",
    amount: "110",
  },
  {
    id: "#3",
    carNumber: "RDX 9087",
    transaction: "Monthly Renewal - Unlimited Shine",
    package: "Unlimited Works",
    dateTime: "2025-12-29T12:29:58.083Z",
    entryType: 2,
    status: 1,
    paymentMethod: "Card Payment",
    amount: "410",
  },
  {
    id: "#4",
    carNumber: "JED 3456",
    transaction: "Single Wash Clean",
    package: "One Time Protect",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 1,
    status: 2,
    paymentMethod: "Apple",
    amount: "110",
  },
  {
    id: "#5",
    carNumber: "DAM 7788",
    transaction: "Monthly Renewal - Unlimited Shine",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    entryType: 2,
    status: 2,
    paymentMethod: "Apple",
    amount: "210",
  },
];

const RecentTransactions = () => {
  const { t } = useTranslation();
  const listData = useSelector((state) => state.Dashboard?.lists);

  const columns = useMemo(
    () => [
      {
        header: t("Name"),
        key: "userInfo",
        render: (value) => value?.name || "-",
      },
      {
        header: t("Phone No."),
        key: "userInfo",
        render: (value) => value?.phone || "-",
      },
      {
        header: t("Invoice Number"),
        key: "invoiceNumber",
        render: (value) => value,
      },
      {
        header: t("Plan Type"),
        key: "planType",
        render: (value) => value,
      },
      {
        header: t("Plan Name"),
        key: "planName",
        render: (value) => value?.en,
      },
      {
        header: t("Date & Time"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Payment Method"),
        key: "paymentMethod",
      },
      {
        header: t("Amount"),
        key: "amount",
        render: (value) => <DisplayPrice value={value} />,
      },
    ],
    [t],
  );

  return (
    <div className="recent_activity">
      <h2 className="fs_20 mb-3">{t("Recent Transactions")}</h2>
      {listData?.lists && (
        <DataTable
          columns={columns}
          data={listData?.lists}
          t={t}
          className="fixed_table"
        />
      )}
    </div>
  );
};

export default RecentTransactions;
